export const isNumber = (evt) => {
  const charCode = evt.which ? evt.which : evt.keyCode
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false
  }
  return true
}

export const shareToNavigator = (text: string, url?: string) => {
  navigator
    .share({
      title: "Macdonalds giftcard",
      text: `${text}`,
      url: url || document.location.href,
    })
    .then(() => {
      console.log("Successfully shared")
    })
    .catch((error) => {
      console.error("Something went wrong sharing the blog", error)
    })
}

export const shareSocialNetworkLinks = (text) => {
  const arr = {
    whatsapp: {
      mobile: `https://wa.me/?text=${encodeURIComponent(text)}`,
      desktop: `https://web.whatsapp.com/send?text=${encodeURIComponent(text)}`,
    },
    telegram: {
      mobile: `https://t.me/share/url?url=${encodeURIComponent(text)}`,
      desktop: `https://t.me/share/url?url=${encodeURIComponent(text)}`,
    },
  }

  return arr
}

export const formatPhoneNumber = (value: string) => {
  let number = value
    ?.trim()
    .replace(/[^0-9]/g, "")
    .replace("972", "") // remove international code
  if (number) {
    if (number.length < 4) return number
    // add zero to number if it doesnt start with one
    if (number && number[0] !== "0") number = "0" + number
    if (number.length === 8) {
      return number.replace(/(\d{2})(\d{6})/, "$1-$2")
    } else if (number.length >= 9) {
      return number.replace(/(\d{3})(\d{6})/, "$1-$2")
    } else {
      return number
    }
  }
  return ""
}

export const formatGiftCardNumber = (value: string) => {
  const number = value?.trim().replace(/[^0-9]/g, "")
  if (number) {
    if (number.length < 4) return number
    if (number.length < 9) return number.replace(/(\d{4})(\d{1})/, "$1-$2")
    if (number.length < 13)
      return number.replace(/(\d{4})(\d{4})(\d{1})/, "$1-$2-$3")
    if (number.length < 16)
      return number.replace(/(\d{4})(\d{4})(\d{4})(\d{1})/, "$1-$2-$3-$4")
    return number.replace(/(\d{3})(\d{4})(\d{4})(\d{4})/, "$1-$2-$3-$4")
  }
}

export function isWebview() {
  const webviewPatterns = [/WebView/i]

  const userAgent = window.navigator.userAgent
  return webviewPatterns.some((pattern) => pattern.test(userAgent))
}

export const formatPhoneNumberPayment = (phoneNumber) => {
  // Remove any non-numeric characters from the phone number
  if (phoneNumber) {
    const numericPhoneNumber = phoneNumber.replace(/\D/g, "")
    // Use regular expressions to add the dashes in the desired format
    const formattedPhoneNumber = numericPhoneNumber.replace(
      /(\d{3})(\d{4})(\d{3})/,
      "$1-$2-$3"
    )

    return formattedPhoneNumber
  }
  return ""
}
